export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-14 md:py-20">
      <div className="w-full max-w-[860px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">联系我们</h2>
          <p className="text-sm text-foreground-500">如有<strong>免费漫画资源</strong>相关建议或合作意向，欢迎与我们取得联系</p>
        </div>
        <div className="bg-background-50 rounded-xl border border-background-200/60 p-6 md:p-10">
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12">
            <div className="flex-shrink-0 w-full md:w-auto">
              <div className="w-20 h-20 md:w-24 md:h-24 rounded-2xl bg-primary-50 flex items-center justify-center mx-auto">
                <i className="ri-mail-send-line text-3xl md:text-4xl text-primary-500"></i>
              </div>
            </div>
            <div className="flex-1 text-center md:text-left">
              <h3 className="text-lg md:text-xl font-heading text-foreground-900 mb-3">期待你的声音</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-5">
                无论你是想要推荐新的<strong>免费完整版漫画</strong>资源，还是在使用<strong>在线免费阅读</strong>过程中有任何问题，或是希望与UU漫画进行商务合作，都欢迎通过以下方式联系我们。我们会在收到信息后的48小时内回复。
              </p>
              <div className="flex flex-col sm:flex-row items-center gap-3">
                <div className="flex items-center gap-2 text-sm text-foreground-600">
                  <i className="ri-mail-line text-primary-500"></i>
                  <span>contact@uumanga.com</span>
                </div>
                <div className="hidden sm:block w-px h-4 bg-background-200"></div>
                <div className="flex items-center gap-2 text-sm text-foreground-600">
                  <i className="ri-wechat-line text-primary-500"></i>
                  <span>UU漫画官方</span>
                </div>
                <div className="hidden sm:block w-px h-4 bg-background-200"></div>
                <div className="flex items-center gap-2 text-sm text-foreground-600">
                  <i className="ri-weibo-line text-primary-500"></i>
                  <span>@UU漫画</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}